import React, { useState, useCallback, useMemo } from 'react';
import { FaEye,FaSearch } from 'react-icons/fa';
import { Badge, Loading, EmptyState } from '../../../common';
import {
  getInitials,
  formatType,
  getRiskClassName,
} from '../../../../utils/helpers';
import { TYPE_COLORS } from '../../../../utils/constants';
import './../IdentityTable/IdentityTable.css';

/**
 * IdentityTable Component
 * Displays identities in a responsive table
 * Does NOT handle modal — parent does
 */
const DarkWebIdentityTable = ({
  darkwebIdentities = [],
  loading = false,
  selectedId = null,
}) => {
  // console.log("darkwebideddd",darkwebIdentities);
  /* ── CONDITIONAL RENDERING (after hooks) ─────── */
  if (loading) {
    return <Loading text="Loading identities…" />;
  }

  if (!darkwebIdentities.length) {
    return (
      <EmptyState
        title="No identities found"
        description="Try adjusting your filters or search"
      />
    );
  }

  /* ──────────────────────────────────────────── */
  return (
    <div
      className="identity-table-container"
      role="region"
      aria-label="Identities table"
    >
      <table className="identity-table" role="table">
        <thead>
          <tr>
            <th scope="col" className="th-identity">
              Identity
            </th>
            <th scope="col" className="th-type">
              Type
            </th>
            <th scope="col" className="th-status">
              Status
            </th>
            <th scope="col" className="th-owner">
              Owner
            </th>
            <th scope="col" className="th-identity">
              Source
            </th>
          </tr>
        </thead>

        <tbody>
          {darkwebIdentities?.map((identity) => {
            const rowId = identity?.id || identity?.objectId;

            return (
              <tr
                key={rowId}
                className={`identity-row ${
                  selectedId === rowId ? 'identity-row--selected' : ''
                }`}
                role="row"
              >
                {/* ── Identity ──────────────────────── */}
                <td className="td-identity">
                  <div className="identity-cell">
                    <div
                      className="identity-avatar"
                      style={{
                        backgroundColor: `${
                          TYPE_COLORS[identity?.type] || '#999'
                        }15`,
                        color: TYPE_COLORS[identity?.type] || '#999',
                      }}
                      aria-hidden="true"
                    >
                      {getInitials(identity?.display_name || 'NA')}
                    </div>

                    <div className="identity-info">
                      <div className="identity-name">
                        {identity?.display_name || 'Unnamed'}
                      </div>
                      <div className="identity-secondary">
                        {identity?.email ||
                          identity?.upn ||
                          identity?.type ||
                          'N/A'}
                      </div>
                    </div>
                  </div>
                </td>

                {/* ── Type ──────────────────────────── */}
                <td className="td-type">
                  <Badge>{formatType(identity?.type || 'unknown')}</Badge>
                </td>

                {/* ── Status ────────────────────────── */}
                <td className="td-status">
                  <span className="cell-text">
                    {identity.status || 'unknown'}
                  </span>
                </td>

                {/* ── Owner ─────────────────────────── */}
                <td className="td-owner">
                  <span className="cell-text">
                    {typeof identity?.owner === 'object'
                      ? identity?.owner?.name || identity?.owner?.email || 'N/A'
                      : identity?.owner || 'N/A'}
                  </span>
                </td>
               <td className="td-identity">
                  <span className="cell-text">
                    {identity.darkweb_url || 'unknown'}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DarkWebIdentityTable;